import { render, staticRenderFns } from "./TimeZoneSettings.vue?vue&type=template&id=48bd4ac5&"
import script from "./TimeZoneSettings.vue?vue&type=script&lang=ts&"
export * from "./TimeZoneSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports